/**
 * Return a shallow copy of `obj` with every string field trimmed.
 * Non-string values are left untouched.
 *
 * Use this at API boundaries to strip accidental whitespace (tabs / trailing
 * spaces from paste-copy) from identifier-like fields before sending to the
 * backend.
 */
export const trimStrings = <T extends object>(obj: T): T =>
  Object.fromEntries(
    Object.entries(obj).map(([key, value]) => [
      key,
      typeof value === 'string' ? value.trim() : value,
    ])
  ) as T;
